import {
  isIosDevice,
  isAndroid,
} from "@erinfo/react-utils/src/helpers/check-browser"
import Box from "@mui/material/Box"

export const CameraPermissionHelper = () => {
  return (
    <Box sx={{ padding: 2, fontSize: 18 }}>
      {isIosDevice && (
        <p>
          Your browser camera permissions are currently set to request
          permission every time you use the camera. To permanently grant access
          to ERinfo, tap the icon to the left of the address bar, scroll down
          and tap the ellipsis icon ('...'), then scroll down and change the
          camera setting to "Allow".
        </p>
      )}
      {isAndroid && (
        <p>
          Your browser camera permissions are currently set to request
          permission every time you use the camera. To permanently grant access
          to ERinfo, tap the icon to the left of the address bar, scroll down
          and tap the ellipsis icon ('...'), then scroll down and change the
          camera setting to "Allow".
        </p>
      )}
    </Box>
  )
}
